import React from "react";
import { Space, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { ModalComponent } from "../ModalComponent";
import { ReactComponent as DeleteIcon } from "../../assets/svg/delete-new-icon.svg";

const { Text } = Typography;

// Shared "Unsaved Changes" confirmation for a saved list with unsaved filter/column edits.
// Consumers control visibility and supply the confirm/cancel behavior (e.g. discard + navigate,
// or discard in place + open another flow) so the markup and copy stay in a single place.
const DiscardListChangesModal = ({ open, onOk, onCancel }) => {
  const { t } = useTranslation();

  return (
    <ModalComponent
      open={open}
      onCancel={onCancel}
      okText={t("savedList.discard_modal.ok_text")}
      cancelText={t("savedList.discard_modal.cancel_text")}
      onOk={onOk}
    >
      <Space direction="vertical">
        <DeleteIcon style={{ width: "48px" }} />
        <Text className="title">{t("savedList.discard_modal.title")}</Text>
        <Text className="content">{t("savedList.discard_modal.content")}</Text>
      </Space>
    </ModalComponent>
  );
};

export default React.memo(DiscardListChangesModal);
